<template>
    <div>
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-row type="flex" class="row-bg" justify="end">
                <el-col :span="3">
                    <el-menu-item index="3">
                        云检查
                    </el-menu-item>
                </el-col>
                <el-col :span="3">
                    <el-menu-item index="1">
                        云对象库
                    </el-menu-item>
                </el-col>
                <el-col :span="3">
                    <el-menu-item index="2">
                        我
                    </el-menu-item>
                </el-col>
            </el-row>
        </el-menu>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeIndex:''
        };
    },
    props:['active_index'],
    created(){
        this.activeIndex = this.active_index
    },
    methods: {
        handleSelect(key, keyPath) {
            if (key == 1) {
                var path = '/newduixiang'
                this.activeIndex = '1'
            }
            if (key == 2) {
                var path = '/me'
                this.activeIndex = '2'
            }
            if (key == 3) {
                var path = '/yunjiancha'
                this.activeIndex = '3'
            }
            this.$router.push({
                path: path
            })
        }
    }
}
</script>
<style scoped>
a {
    text-decoration: none;
}
</style>